@if (showSupportWidget$ | async) {
  <div class="support-widget d-flex flex-column align-items-end">
    @if (isSupportWidgetOpen) {
      <div class="support-widget__content udex-mb-24">
        @if (isSapProduct || !isProductDetailsPage) {
          @if (shouldShowChat()) {
            @if (isAgentAvailable) {
              <button
                type="button"
                class="btn btn-link border-0 bg-transparent d-flex udex-py-16 udex-p-0 text-start"
                (click)="openChat()"
                [attr.data-cy]="'chatNow'">
                <img
                  class="icon-img udex-mt-4 udex-ms-4 udex-me-24"
                  alt="{{ 'productDetails.chatNow' }} image"
                  src="/images/product/support-widget/discussion-2_blue.svg"/>
                <div class="d-flex flex-column">
                  <span
                    class="body--s text-decoration-underline text-blue">
                    {{'productDetails.chatNow' | cxTranslate}}
                  </span>
                  <p class="body--xs text-grey">{{'productDetails.chatNowDescription' | cxTranslate}}</p>
                </div>
              </button>
            } @else {
              <div
                class="d-flex udex-py-16 udex-p-0 text-start"
                [attr.data-cy]="'chatUnavailable'">
                <img
                  class="icon-img udex-mt-4 udex-ms-4 udex-me-24"
                  alt="{{ 'productDetails.chatNow' }} image"
                  src="/images/product/support-widget/discussion-2_blue.svg"/>
                <p class="body--xs text-grey">
                  {{'productDetails.chatUnavailable' | cxTranslate}}
                </p>
              </div>
            }
          }
          <button
            type="button"
            (click)="openSupportRequestModal()"
            class="btn btn-link border-0 bg-transparent d-flex udex-py-16 udex-p-0 text-start"
            [attr.data-cy]="'contactSupport'">
            <img
              class="icon-img udex-mt-4 udex-ms-4 udex-me-24"
              alt="{{ 'productDetails.contactSupport' }} image"
              src="/images/product/support-widget/email_blue.svg"/>
            <div class="d-flex flex-column">
              <span
                class="body--s text-decoration-underline text-blue">
                {{'productDetails.contactSupport' | cxTranslate}}
              </span>
              <span class="body--xs text-grey">{{'productDetails.contactSupportDescription' | cxTranslate}}</span>
            </div>
          </button>
        } @else {
          @if (partnerCommercialModelConfig?.actionType === 'popup') {
            <div>
              <button
                type="button"
                (click)="openEddlModal()"
                class="btn btn-link border-0 bg-transparent d-flex udex-py-16 udex-p-0 text-start"
                [attr.data-cy]="'askPublisher'">
                <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
              </button>
              <dcp-lead-form-modal [context]="leadFormContext"></dcp-lead-form-modal>
            </div>
          } @else {
            <button
              type="button"
              (click)="openLeadRfiForm()"
              class="btn btn-link border-0 bg-transparent d-flex udex-py-16 udex-p-0 text-start"
              [attr.data-cy]="'askPublisher'">
              <ng-container *ngTemplateOutlet="ctaContent"></ng-container>
            </button>
          }

          <ng-template #ctaContent>
            <img
              class="icon-img udex-mt-4 udex-ms-4 udex-me-24"
              alt="{{ 'productDetails.askPublisher' }} image"
              src="/images/product/support-widget/discussion-2_blue.svg"/>
            <div class="d-flex flex-column">
              <span
                class="body--s text-decoration-underline text-blue">
                {{'productDetails.askPublisher' | cxTranslate}}
              </span>
              <span class="body--xs text-grey">{{'productDetails.askPublisherDescription' | cxTranslate}}</span>
            </div>
          </ng-template>

          <button
            type="button"
            (click)="openSupportRequestModal()"
            class="btn btn-link border-0 bg-transparent d-flex udex-py-16 udex-p-0 text-start"
            [attr.data-cy]="'askSapStore'">
            <img
              class="icon-img udex-mt-4 udex-ms-4 udex-me-24"
              alt="{{ 'productDetails.contactSupport' }} image"
              src="/images/product/support-widget/email_blue.svg"/>
            <div class="d-flex flex-column">
              <span
                class="body--s text-decoration-underline text-blue">
                {{'productDetails.contactSupport' | cxTranslate}}
              </span>
              <span class="body--xs text-grey">{{'productDetails.contactSupportDescription' | cxTranslate}}</span>
            </div>
          </button>
        }
      </div>
    }

    <udex-button
      size="Large"
      (click)="toggleSupportWidget()"
      icon="sap-icon://discussion-2"
      [active]="isSupportWidgetOpen"
      [attr.data-cy]="'support-widget-button'">
      <span class="button-text">{{'productDetails.contactUs' | cxTranslate}}</span>
    </udex-button>
  </div>

}
